"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Data = void 0;
const json_rpc_base_types_1 = require("./json-rpc-base-types");
const json_rpc_base_types_2 = require("./json-rpc-base-types");
function validateByteLength(byteLength) {
    if (typeof byteLength !== "number" || !(byteLength >= 0)) {
        throw new Error(`byteLength must be a number greater than or equal to 0, provided: ${byteLength}`);
    }
}
class Data extends json_rpc_base_types_1.BaseJsonRpcType {
    constructor(value, _byteLength) {
        super(value);
        this._byteLength = _byteLength;
        if (typeof value === "bigint") {
            throw new Error(`Cannot create a ${typeof value} as a Data`);
        }
        if (_byteLength !== undefined) {
            validateByteLength(_byteLength);
        }
    }
    toString(byteLength) {
        if (byteLength === undefined) {
            byteLength = this._byteLength;
        }
        if (byteLength === undefined && json_rpc_base_types_2.strCache.has(this)) {
            return json_rpc_base_types_2.strCache.get(this);
        }
        else {
            let str = json_rpc_base_types_2.toStrings.get(this)();
            let length = str.length;
            if (length % 2 === 1) {
                length++;
                str = `0${str}`;
            }
            if (byteLength !== undefined) {
                validateByteLength(byteLength);
                const strLength = byteLength * 2;
                const padBy = strLength - length;
                if (padBy < 0) {
                    // if our hex-encoded data is longer than it should be, truncate it:
                    str = str.slice(0, strLength);
                }
                else if (padBy > 0) {
                    // if our hex-encoded data is shorter than it should be, pad it:
                    str = "0".repeat(padBy) + str;
                }
            }
            return `0x${str}`;
        }
    }
    static from(value, byteLength) {
        return new Data(value, byteLength);
    }
}
exports.Data = Data;
//# sourceMappingURL=json-rpc-data.js.map